document.addEventListener("DOMContentLoaded", function() {
const stickyCartId = 'monster-upsell-sticky-cart';
// Target the button by name and class from your snippet to ensure uniqueness
const mainButtonSelector = 'button[name="add"].product-form__submit';

const checkStockStatus = () => {
    const stickyCart = document.getElementById(stickyCartId);
    const mainButton = document.querySelector(mainButtonSelector);

    if (!stickyCart || !mainButton) return;

    // Check if the button has the 'disabled' attribute
    if (mainButton.hasAttribute('disabled')) {
    stickyCart.style.setProperty('display', 'none', 'important');
    } else {
    // Force flex display if in stock
    stickyCart.style.setProperty('display', 'flex', 'important');
    }
};

// Run immediately
checkStockStatus();

// Watch for variant changes (attributes changing on the button)
const observer = new MutationObserver(checkStockStatus);

// Observer config: watch the body for attribute changes to catch when the button updates
observer.observe(document.body, { 
    subtree: true, 
    attributes: true, 
    attributeFilter: ['disabled'] // Only trigger when 'disabled' toggles
});
});